import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';

@Injectable()
export class RegioniProvinceComuniService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.baseUrl;

  getAllRegioni(): Observable<{ nome: string }[]> {
    const reqUrl = `${this.baseUrl}v1/regioni`;
    return this.httpClient.get<{ nome: string }[]>(reqUrl);
  }

  getAllProvince(regione: string): Observable<{ nome: string }[]> {
    const reqUrl = `${this.baseUrl}v1/province?regione=${regione}`;
    return this.httpClient.get<{ nome: string }[]>(reqUrl);
  }

  getAllComuni(provincia: string): Observable<{ nome: string }[]> {
    const reqUrl = `${this.baseUrl}v1/comuni?provincia=${provincia}`;
    return this.httpClient.get<{ nome: string }[]>(reqUrl);
  }
}
